var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlcoholIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "81px",
    viewBox: "0 0 58 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50.3201244%",
    fx: "50%",
    fy: "50.3201244%",
    r: "42.199855%",
    gradientTransform: "translate(0.500000,0.503201),scale(0.052632,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.503201)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.12538243,
    offset: "0.279771959%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.2850538%",
    y1: "0%",
    x2: "31.2850538%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.9827907,13.03545 L0.0944136873,13.03545 C0.459848114,16.0014481 1.93673336,18.8630116 5.49045467,20.8677896 C5.49045467,20.8677896 5.49424156,20.8677896 5.50208582,20.8717354 C5.74147106,20.9632802 8.78747926,22.3735433 10.9790039,22.3790675 L10.9827907,22.3790675 C13.1705284,22.3735433 16.220053,20.9632802 16.4597088,20.8717354 C16.4672825,20.8677896 16.4713399,20.8677896 16.4713399,20.8677896 C20.0250612,18.8630116 21.5019465,16.0014481 21.8673809,13.03545 L10.9827907,13.03545 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-42.8%",
    width: "136.7%",
    height: "185.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.274256993 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "35.0428916%",
    x2: "50%",
    y2: "0.885115607%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    stopOpacity: 0.4,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    stopOpacity: 0.222191871,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.4173661,-1.24344979e-14 L10.9828989,-1.24344979e-14 L3.54437434,-1.24344979e-14 C3.54437434,-1.24344979e-14 -0.67854369,6.7477444 0.094521884,13.0353974 L10.9828989,13.0353974 L21.8672186,13.0353974 C22.6402842,6.7477444 18.4173661,-1.24344979e-14 18.4173661,-1.24344979e-14",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.6%",
    y: "-7.7%",
    width: "109.1%",
    height: "115.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.424333479 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "35.0428916%",
    x2: "50%",
    y2: "0.885115607%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    stopOpacity: 0.4,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    stopOpacity: 0.222191871,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "10.9827907 45.8989198 3.00084811 45.8989198 3.27133992 46.8790802 10.9827907 46.8790802 18.6904547 46.8790802 18.9609465 45.8989198"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.3%",
    y: "-102.0%",
    width: "112.5%",
    height: "304.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.424333479 0",
    type: "matrix",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "35.0428916%",
    x2: "50%",
    y2: "0.885115607%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    stopOpacity: 0.4,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    stopOpacity: 0.222191871,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.9827907,22.3790938 L10.9790039,22.3790938 C8.78747926,22.3735696 5.74147106,20.9633065 5.50208582,20.8717618 C6.33276615,21.3429017 7.00845467,21.7656386 8.08149565,22.1283979 C8.08149565,22.1283979 9.92381533,22.7978849 9.92381533,23.8303942 L10.9827907,23.8303942 L12.0379793,23.8303942 C12.0379793,22.8018308 13.8800284,22.1283979 13.8800284,22.1283979 C14.9533399,21.7656386 15.6287579,21.3429017 16.4597088,20.8717618 C16.220053,20.9633065 13.1705284,22.3735696 10.9827907,22.3790938",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.1%",
    y: "-33.8%",
    width: "118.3%",
    height: "167.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.424333479 0",
    type: "matrix",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "35.0428916%",
    x2: "50%",
    y2: "0.885115607%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    stopOpacity: 0.4,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    stopOpacity: 0.222191871,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.0379522,42.7645371 L10.9827637,42.7645371 L9.92378828,42.7645371 C9.92378828,42.7645371 9.14044402,45.8988935 3.00082106,45.8988935 L10.9827637,45.8988935 L18.9571325,45.8988935 C12.8250834,45.8988935 12.0379522,42.7645371 12.0379522,42.7645371",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.3%",
    y: "-31.9%",
    width: "112.5%",
    height: "163.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.424333479 0",
    type: "matrix",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "35.0428916%",
    x2: "50%",
    y2: "0.885115607%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    stopOpacity: 0.4,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    stopOpacity: 0.222191871,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-18",
    points: "12.0379522 42.7645371 12.0379522 23.830289 10.9827637 23.830289 9.92378828 23.830289 9.92378828 42.7645371 10.9827637 42.7645371"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-47.3%",
    y: "-5.3%",
    width: "194.6%",
    height: "110.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-19"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.424333479 0",
    type: "matrix",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.2850538%",
    y1: "0%",
    x2: "31.2850538%",
    y2: "100%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.1359995,24.3718162 C16.1359995,24.3718162 15.5288943,23.7610503 15.0057364,22.8535667 L10.0128416,22.8535667 L5.02021006,22.8535667 C4.49731533,23.7610503 3.89021006,24.3718162 3.89021006,24.3718162 C-0.375579411,27.5908096 0.0373153255,33.1945733 0.0373153255,33.1945733 L0.0373153255,76.4830635 C0.0373153255,80.0599562 0.75678901,79.931291 1.27573638,79.931291 L10.0128416,79.931291 L18.7504732,79.931291 C19.2281048,79.931291 19.9891574,80.0599562 19.9891574,76.4830635 L19.9891574,33.1945733 C19.9891574,33.1945733 20.401789,27.5908096 16.1359995,24.3718162",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-20.0%",
    y: "-7.0%",
    width: "140.1%",
    height: "114.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-22"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.274256993 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "35.0428916%",
    x2: "50%",
    y2: "0.885115607%",
    id: "linearGradient-23"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    stopOpacity: 0.4,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    stopOpacity: 0.222191871,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "91.8760557%",
    y1: "83.7378561%",
    x2: "7.54328547%",
    y2: "83.7378561%",
    id: "linearGradient-24"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.0024732,6.7270372 L10.0129995,6.7270372 L6.02378901,6.7270372 C6.02378901,6.7270372 5.95431533,12.7370153 5.86536796,16.9414792 L10.0129995,16.9414792 L14.1608943,16.9414792 C14.0714206,12.7370153 14.0024732,6.7270372 14.0024732,6.7270372",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.1%",
    y: "-9.8%",
    width: "124.1%",
    height: "119.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-26"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.112680288 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "35.0428916%",
    x2: "50%",
    y2: "0.885115607%",
    id: "linearGradient-27"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    stopOpacity: 0.4,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    stopOpacity: 0.222191871,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.6908153,0.84892779 C14.6908153,0.379956236 14.3097627,-1.2490009e-13 13.8400259,-1.2490009e-13 L10.0129206,-1.2490009e-13 L6.18634164,-1.2490009e-13 C5.71634164,-1.2490009e-13 5.33528901,0.379956236 5.33528901,0.84892779 L5.33528901,1.19369803 L14.6908153,1.19369803 L14.6908153,0.84892779 Z",
    id: "path-28"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.7%",
    y: "-83.8%",
    width: "121.4%",
    height: "267.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-29"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.424333479 0",
    type: "matrix",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "91.8760557%",
    y1: "83.7378561%",
    x2: "7.54328547%",
    y2: "83.7378561%",
    id: "linearGradient-30"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HH---Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HH---Dashboard-100%-LG-03.11.0",
    transform: "translate(-890.000000, -1299.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(890.000000, 1299.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow-large-copy-9",
    transform: "translate(0.000000, 73.000000)",
    fill: "url(#radialGradient-1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow-copy",
    cx: 19,
    cy: 1,
    rx: 19,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow-large-copy-9",
    transform: "translate(20.000000, 79.000000)",
    fill: "url(#radialGradient-1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow-copy",
    cx: 19,
    cy: 1,
    rx: 19,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(9.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-91-Copy",
    transform: "translate(11.000000, 50.500000) scale(-1, 1) translate(-11.000000, -50.500000) translate(0.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-16"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-2)",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-18",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-5)",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-20",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-23",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-11)",
    fillRule: "evenodd",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-31",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-14)",
    fillRule: "evenodd",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-16)",
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-33",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-17)",
    fillRule: "evenodd",
    xlinkHref: "#path-18"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-19)",
    xlinkHref: "#path-18"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.2137439,42.776483 C10.1962218,43.5460097 8.03189112,45.8970201 6.09389483,45.8954359 C7.47916742,45.9020867 8.41404591,45.9068161 8.8985303,45.9096242 C9.6252569,45.9138039 10.1519763,44.2941285 10.2137439,42.776483 Z",
    id: "Fill-6",
    fill: "#FFFFFF",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61294581,19.6459397 C4.83416954,18.0620573 3.37677208,15.8822032 3.00616021,12.8791136 C2.42531822,8.16113787 5.62011613,1.73399707 6.56940267,0.0127974434 L4.94905941,0.0127974434 C3.99977287,1.73399707 0.804974955,8.16113787 1.38581695,12.8791136 C1.75642881,15.8822032 3.28791192,18.1129494 6.06668819,19.6968319 L6.09811434,19.7120894 L6.44624025,19.9104364 C7.13002998,20.3016062 10.33204,22.4857771 10.326757,23.7900291 C10.3404488,23.1798197 10.3917221,21.2298222 7.61294581,19.6459397 Z",
    id: "Fill-8",
    fill: "#FFFFFF",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2414358,24.6543498 C10.4406205,24.6543498 10.6020916,24.8158209 10.6020916,25.0150056 L10.6020916,41.8310075 C10.6020916,42.0301922 10.4406205,42.1916632 10.2414358,42.1916632 L10.2414358,42.1916632 L10.2414358,42.1916632 L10.2414358,24.6543498 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-96-Copy",
    transform: "translate(30.000000, 40.000000) scale(-1, 1) translate(-30.000000, -40.000000) translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-25"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-20)",
    fillRule: "evenodd",
    xlinkHref: "#path-21"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-22)",
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.2781048,20.6756586 C14.2378416,20.1027046 14.1978416,18.6755711 14.1609995,16.9414792 L10.0128416,16.9414792 L5.86547322,16.9414792 C5.82836796,18.6755711 5.78836796,20.1027046 5.7481048,20.6756586 C5.69152585,21.4736455 5.37547322,22.2332954 5.02021006,22.8535142 L10.0128416,22.8535142 L15.0057364,22.8535142 C14.6507364,22.2332954 14.3344206,21.4736455 14.2781048,20.6756586",
    id: "Fill-27",
    fill: "url(#linearGradient-23)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-29"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-24)",
    fillRule: "evenodd",
    xlinkHref: "#path-25"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-26)",
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-35",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-27)",
    fillRule: "evenodd",
    xlinkHref: "#path-28"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-29)",
    xlinkHref: "#path-28"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.33534164,1.19382932 L5.33534164,5.7131291 C5.33534164,6.48853392 6.02376269,6.72695842 6.02376269,6.72695842 L10.0129732,6.72695842 L14.0024469,6.72695842 C14.0024469,6.72695842 14.690868,6.48853392 14.690868,5.7131291 L14.690868,1.19382932 L5.33534164,1.19382932 Z",
    id: "Fill-37",
    fill: "url(#linearGradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.84241939,33.1274547 C2.84241939,33.0875423 2.84162869,33.1372254 2.83899299,33.0973129 C2.82660521,32.8995886 2.57305114,28.1563063 6.15575438,25.4362188 C6.22849962,25.3813392 6.29702775,25.3206827 6.36107519,25.2534617 C6.53107766,25.0759562 7.13017164,24.4223895 7.65810179,23.5080788 C8.19367547,22.5740744 8.49625351,21.6534617 8.5589831,20.7685602 C8.59720071,20.2258031 8.63620903,18.9837899 8.67943447,16.969523 C8.75824181,13.2474223 8.82255283,8.05564989 8.83467703,7.05258643 C8.83968486,6.63324289 8.70368288,6.23385558 8.45698162,5.91403063 C8.26194003,5.66090153 8.14913219,5.35473085 8.14913219,5.03595624 L8.14886862,0.593155361 C8.14886862,0.315080963 8.37738357,0.00465385243 8.65676747,0.00465385243 L7.08035696,0.00465385243 C6.80097306,0.00465385243 6.57245811,0.315080963 6.57245811,0.593155361 L6.57245811,5.03595624 C6.57245811,5.35473085 6.68552952,5.66090153 6.88057111,5.91403063 C7.12727237,6.23385558 7.26327435,6.63324289 7.25826652,7.05258643 C7.24614232,8.05564989 7.1818313,13.2474223 7.10302396,16.969523 C7.05979852,18.9837899 7.0207902,20.2258031 6.98283616,20.7685602 C6.919843,21.6534617 6.61726496,22.5740744 6.08169128,23.5080788 C5.55376113,24.4223895 4.95466715,25.0759562 4.78466468,25.2534617 C4.72061724,25.3206827 4.65208911,25.3813392 4.57934387,25.4362188 C0.996640628,28.1563063 1.2501947,32.8995886 1.26258248,33.0973129 C1.26521818,33.1372254 1.26600888,33.1703107 1.26600888,33.2102232 L1.26600888,77.794844 C1.26600888,79.0021963 1.54095581,79.7729283 1.87281574,79.9301613 L3.44922625,79.9301613 C3.0647788,79.5784706 2.84241939,79.0021963 2.84241939,77.794844 L2.84241939,33.1274547 Z",
    id: "Fill-10",
    fill: "#FFFFFF",
    opacity: 0.534388951
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-94",
    transform: "translate(4.642556, 39.737418)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.40227937,10.3694528 C4.50511534,10.3694528 3.77782229,11.1047551 3.77782229,12.0118389 C3.77782229,12.9189227 4.50511534,13.6542896 5.40227937,13.6542896 C6.29944339,13.6542896 7.02673645,12.9189227 7.02673645,12.0118389 C7.02673645,11.1047551 6.29944339,10.3694528 5.40227937,10.3694528",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28525202,7.15558664 C6.37687884,7.15558664 5.64049901,7.89284774 5.64049901,8.80234795 C5.64049901,9.71184817 6.37687884,10.4491416 7.28525202,10.4491416 C8.19359286,10.4491416 8.92997269,9.71184817 8.92997269,8.80234795 C8.92997269,7.89284774 8.19359286,7.15558664 7.28525202,7.15558664",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51330602,7.15558664 C2.60494178,7.15558664 1.86856918,7.89284774 1.86856918,8.80234795 C1.86856918,9.71184817 2.60494178,10.4491416 3.51330602,10.4491416 C4.42167027,10.4491416 5.15804287,9.71184817 5.15804287,8.80234795 C5.15804287,7.89284774 4.42167027,7.15558664 3.51330602,7.15558664",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39927094,3.81871912 C4.49090669,3.81871912 3.75453409,4.55600535 3.75453409,5.46549663 C3.75453409,6.3749879 4.49090669,7.11227413 5.39927094,7.11227413 C6.30763518,7.11227413 7.04400778,6.3749879 7.04400778,5.46549663 C7.04400778,4.55600535 6.30763518,3.81871912 5.39927094,3.81871912",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12734111,3.81871912 C8.21895901,3.81871912 7.48260427,4.55600535 7.48260427,5.46549663 C7.48260427,6.3749879 8.21895901,7.11227413 9.12734111,7.11227413 C10.0357232,7.11227413 10.772078,6.3749879 10.772078,5.46549663 C10.772078,4.55600535 10.0357232,3.81871912 9.12734111,3.81871912",
    id: "Fill-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66683737,3.83510376 C0.760877619,3.83510376 0.0264542441,4.56329918 0.0264542441,5.46157634 C0.0264542441,6.3598535 0.760877619,7.08804892 1.66683737,7.08804892 C2.57279712,7.08804892 3.3072205,6.3598535 3.3072205,5.46157634 C3.3072205,4.56329918 2.57279712,3.83510376 1.66683737,3.83510376",
    id: "Fill-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.81549729,3.03007061 L5.02646392,3.03007061 L5.02646392,2.81884223 C5.02646392,1.26203191 3.76596435,1.39888101e-14 2.21111476,1.39888101e-14 L2.00014813,1.39888101e-14 L2.00014813,0.211228378 C2.00014813,1.76800711 3.26061615,3.03007061 4.81549729,3.03007061",
    id: "Fill-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79839374,0.211228378 L8.79839374,1.27675648e-13 L8.58742932,1.27675648e-13 C7.03253283,1.27675648e-13 5.77207795,1.26203191 5.77207795,2.81884223 L5.77207795,3.03007061 L5.98307393,3.03007061 C7.53790732,3.03007061 8.79839374,1.7680387 8.79839374,0.211228378",
    id: "Fill-17"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcoholIcon);
export default __webpack_public_path__ + "static/media/alcohol-icon.fc436813844898be2a7db466d70d3dfa.svg";
export { ForwardRef as ReactComponent };